function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "255mm",
    height: "255mm",
    viewBox: "0 0 255 255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.631 39.554v173.113h222.25V39.554Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 7,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.875 163.53 68.792-58.965 49.137 68.792 40.065-42.333 65.768 64.256",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.631 12.34 225.274 226.029",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.505,
    cy: 90.649,
    rx: 12.154,
    ry: 11.786,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 8.76988602,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no_image.d3b01d6e7810c02af4cb9ccf6e5e45f6.svg";
export { ForwardRef as ReactComponent };